<div
  #modalContents
  class="l-modal05__contents l-modal05__contents--tbw100 l-modal05__contents--w850 js-modal-contents"
  aria-modal="true"
  role="dialog"
  aria-labelledby="modalTitle"
>
  <div #modalHead class="l-modal05__header js-modal-head">
    <div class="p-modal-head01">
      <h1 id="modalTitle" class="p-modal-head01__title" [innerHTML]="'label.filter' | staticMsg"></h1>
      <button
        id="filter-condition-close-btn"
        class="p-modal-head01__close js-modal-close"
        (throttleClick$)="this.cancelDialog()"
        aswThrottleClick
      >
        <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
      </button>
    </div>
  </div>

  <div #modalBody class="l-modal05__body js-modal-body">
    <div class="p-international-filter">
      <!-- 選択可能な便 -->
      <div class="p-international-filter__box">
        <div class="p-international-filter__box-inner">
          <div class="p-international-filter__box-unit">
            <h2 class="p-international-filter__box-title" [innerHTML]="'label.seatAvaiAbility' | staticMsg"></h2>
            <div class="p-international-filter__box-item">
              <div class="c-form-element-checkbox">
                <div class="c-form-element-checkbox__wrap">
                  <input
                    type="checkbox"
                    name="checkbox-available-flights"
                    id="checkbox-available-flights"
                    class="c-form-element-checkbox__input"
                    aria-invalid="false"
                    [(ngModel)]="this.filterConditionData.isAvailable"
                  />
                  <label for="checkbox-available-flights" class="c-form-element-checkbox__label">
                    <span class="c-form-element-checkbox__check"></span>
                    <span
                      class="c-form-element-checkbox__text"
                      [innerHTML]="'label.showAvailableFlights' | staticMsg"
                    ></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 支払い総額 -->
      <ng-container *ngIf="this.filterConditionData.budgetRange.limitMinValue !== undefined">
        <div class="p-international-filter__box">
          <div class="p-international-filter__box-inner">
            <div class="p-international-filter__box-unit">
              <h2
                class="p-international-filter__box-title"
                [innerHTML]="filterConditionData.budgetLabel ?? 'label.flightBudget' | staticMsg"
              ></h2>
              <div class="p-international-filter__box-item">
                <asw-range-slider
                  #paymentTotalRangeSlider
                  [type]="'amount'"
                  [ariaLabel]="'label.flightBudget'"
                  [handlePoint]="'two'"
                  [valueMin]="filterConditionData.budgetRange.limitMinValue"
                  [valueMax]="filterConditionData.budgetRange.limitMaxValue"
                  [stepGrid]="''"
                  [formControl]="paymentTotalRangeControl"
                ></asw-range-slider>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- 運賃タイプ -->
      <ng-container *ngIf="this.filterConditionData.fareType.length !== 0">
        <div class="p-international-filter__box">
          <div class="p-international-filter__box-inner">
            <div class="p-international-filter__box-unit">
              <h2 class="p-international-filter__box-title" [innerHTML]="'label.fare' | staticMsg"></h2>
              <div class="p-international-filter__box-item">
                <fieldset class="c-checkbox-list c-checkbox-list--vertical" aria-invalid="false">
                  <legend class="c-checkbox-list__legend" [innerHTML]="'label.fare' | staticMsg"></legend>
                  <div class="c-checkbox-list__wrap">
                    <div class="c-checkbox-list__list">
                      <ng-container *ngFor="let fareType of this.filterConditionData.fareType; index as fareIndex">
                        <div class="c-checkbox-list__item">
                          <div class="c-form-element-checkbox">
                            <div class="c-form-element-checkbox__wrap">
                              <input
                                type="checkbox"
                                name="checkbox-fare-type"
                                id="{{ 'checkbox-fare-type-' + fareIndex }}"
                                class="c-form-element-checkbox__input"
                                [(ngModel)]="fareType.isEnabled"
                              />
                              <label
                                for="{{ 'checkbox-fare-type-' + fareIndex }}"
                                class="c-form-element-checkbox__label"
                              >
                                <span class="c-form-element-checkbox__check"></span>
                                <span
                                  class="c-form-element-checkbox__text"
                                  [innerHTML]="fareType.name | staticMsg"
                                ></span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- バウンドのフィルター条件 -->
      <ng-container *ngFor="let bound of this.filterConditionData.boundFilterItemList; index as boundIndex">
        <ng-container [formGroup]="boundControls.controls[boundIndex]">
          <div class="p-international-filter__box">
            <div class="p-international-filter__box-inner">
              <div class="p-international-filter__box-unit">
                <h2
                  *ngIf="this.payload.boundIndex === undefined"
                  class="p-international-filter__box-title"
                  [innerHTML]="'label.number.section.n' | staticMsg : { '0': boundIndex + 1 }"
                ></h2>
                <h2
                  *ngIf="this.payload.boundIndex !== undefined"
                  class="p-international-filter__box-title"
                  [innerHTML]="'label.number.section.n' | staticMsg : { '0': this.payload.boundIndex }"
                ></h2>
                <div class="p-international-filter__box-item">
                  <!-- 乗継回数 -->
                  <div class="p-international-filter__box-item-wrap">
                    <h3
                      class="p-international-filter__box-item-wrap-head"
                      [innerHTML]="'label.numberOfConnection' | staticMsg"
                    ></h3>
                    <div class="p-international-filter__box-item-wrap-body">
                      <fieldset class="c-checkbox-list c-checkbox-list--vertical" aria-invalid="false">
                        <legend
                          class="c-checkbox-list__legend"
                          [innerHTML]="'label.numberOfConnection' | staticMsg"
                        ></legend>
                        <div class="c-checkbox-list__wrap">
                          <div class="c-checkbox-list__list">
                            <ng-container *ngFor="let stop of bound.stops; index as stopIndex">
                              <div class="c-checkbox-list__item">
                                <div class="c-form-element-checkbox">
                                  <div class="c-form-element-checkbox__wrap">
                                    <input
                                      type="checkbox"
                                      name="checkbox-stop"
                                      id="{{ 'checkbox-stop-' + boundIndex + '-' + stopIndex }}"
                                      class="c-form-element-checkbox__input"
                                      [(ngModel)]="stop.isEnabled"
                                      [ngModelOptions]="{ standalone: true }"
                                    />
                                    <label
                                      for="{{ 'checkbox-stop-' + boundIndex + '-' + stopIndex }}"
                                      class="c-form-element-checkbox__label"
                                    >
                                      <span class="c-form-element-checkbox__check"></span>
                                      <span
                                        class="c-form-element-checkbox__text"
                                        *ngIf="stop.item > 0"
                                        [innerHTML]="'label.transitFlight' | staticMsg : { '0': stop.item }"
                                      ></span>
                                      <span
                                        class="c-form-element-checkbox__text"
                                        *ngIf="stop.item === 0"
                                        [innerHTML]="'label.directFlight' | staticMsg"
                                      ></span>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>

                  <!-- 総所要時間 -->
                  <div class="p-international-filter__box-item-wrap">
                    <h3
                      class="p-international-filter__box-item-wrap-head"
                      [innerHTML]="'label.totalTime' | staticMsg"
                    ></h3>
                    <div
                      class="p-international-filter__box-item-wrap-body p-international-filter__box-item-wrap-body--min"
                    >
                      <asw-range-slider
                        [type]="'interval'"
                        [valueMin]="bound.durationRange.limitMinValue"
                        [valueMax]="bound.durationRange.limitMaxValue"
                        [stepGrid]="30"
                        [handlePoint]="'two'"
                        [ariaLabel]="'label.totalTime'"
                        formControlName="totalTravelTimeRangeControl"
                      ></asw-range-slider>
                    </div>
                  </div>
                </div>

                <div class="p-international-filter__box-item">
                  <!-- 出発空港 -->
                  <div class="p-international-filter__box-item-wrap">
                    <!-- 出発時間帯 -->
                    <h3
                      class="p-international-filter__box-item-wrap-head"
                      [innerHTML]="'label.departureTime' | staticMsg"
                    ></h3>
                    <div
                      class="p-international-filter__box-item-wrap-body p-international-filter__box-item-wrap-body--min"
                    >
                      <ng-container>
                        <asw-range-slider
                          *ngIf="bound.departureTimeRange.limitMinValue && bound.departureTimeRange.limitMaxValue"
                          [type]="'time'"
                          [valueMin]="bound.departureTimeRange.limitMinValue"
                          [valueMax]="bound.departureTimeRange.limitMaxValue"
                          [handlePoint]="'two'"
                          [stepGrid]="'120'"
                          [ariaLabel]="'label.departureTime'"
                          formControlName="departureTimeRangeControl"
                        ></asw-range-slider>
                        <asw-range-slider
                          *ngIf="!(bound.departureTimeRange.limitMinValue && bound.departureTimeRange.limitMaxValue)"
                          [type]="'time'"
                          [valueMin]="0"
                          [valueMax]="1439"
                          [handlePoint]="'two'"
                          [stepGrid]="'120'"
                          [ariaLabel]="'label.departureTime'"
                          formControlName="departureTimeRangeControl"
                        ></asw-range-slider>
                      </ng-container>
                    </div>
                  </div>
                </div>

                <!-- 到着空港 -->
                <div class="p-international-filter__box-item">
                  <!-- 到着時間帯 -->
                  <div class="p-international-filter__box-item-wrap">
                    <h3
                      class="p-international-filter__box-item-wrap-head"
                      [innerHTML]="'label.arrivalTime' | staticMsg"
                    ></h3>
                    <div
                      class="p-international-filter__box-item-wrap-body p-international-filter__box-item-wrap-body--min"
                    >
                      <asw-range-slider
                        [type]="'time'"
                        [ariaLabel]="'label.arrivalTime'"
                        [valueMin]="0"
                        [valueMax]="1439"
                        [handlePoint]="'two'"
                        [stepGrid]="'120'"
                        unitFront=""
                        unitBack="h"
                        formControlName="arrivalTimeRangeControl"
                      >
                      </asw-range-slider>
                    </div>
                  </div>
                </div>

                <!-- 乗継空港 -->
                <ng-container *ngIf="bound.transitAirportList.length !== 0">
                  <div class="p-international-filter__box-item">
                    <div class="p-international-filter__box-item-wrap">
                      <h3
                        class="p-international-filter__box-item-wrap-head"
                        [innerHTML]="'label.transitAirport' | staticMsg"
                      ></h3>
                      <div class="p-international-filter__box-item-wrap-body">
                        <fieldset
                          [ngClass]="{ 'is-error': errorMessages[boundIndex].transitAirportErrors !== '' }"
                          class="c-checkbox-list c-checkbox-list--vertical"
                          aria-invalid="false"
                        >
                          <legend
                            class="c-checkbox-list__legend"
                            [innerHTML]="'label.transitAirport' | staticMsg"
                          ></legend>
                          <div class="c-checkbox-list__wrap">
                            <div class="c-checkbox-list__list">
                              <ng-container *ngFor="let airport of bound.transitAirportList; index as airportIndex">
                                <div class="c-checkbox-list__item">
                                  <div class="c-form-element-checkbox">
                                    <div class="c-form-element-checkbox__wrap">
                                      <input
                                        type="checkbox"
                                        name="checkbox-transit-airport"
                                        id="{{ 'checkbox-transit-airport-' + boundIndex + '-' + airportIndex }}"
                                        class="c-form-element-checkbox__input"
                                        (change)="checkTransitAirportStatus(boundIndex)"
                                        [(ngModel)]="airport.isEnabled"
                                        [ngModelOptions]="{ standalone: true }"
                                      />
                                      <label
                                        for="{{ 'checkbox-transit-airport-' + boundIndex + '-' + airportIndex }}"
                                        class="c-form-element-checkbox__label"
                                      >
                                        <span class="c-form-element-checkbox__check"></span>
                                        <span class="c-form-element-checkbox__text" [innerHTML]="airport.name"></span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </fieldset>
                        <asw-validation-error
                          *ngIf="errorMessages[boundIndex]?.transitAirportErrors !== ''"
                          id="transit_airport_error"
                          [errorMessage]="errorMessages[boundIndex].transitAirportErrors"
                        ></asw-validation-error>
                      </div>
                    </div>

                    <!-- 乗継時間 -->
                    <div class="p-international-filter__box-item-wrap">
                      <h3
                        class="p-international-filter__box-item-wrap-head"
                        [innerHTML]="'reader.transferconditionTime' | staticMsg"
                      ></h3>
                      <div
                        class="p-international-filter__box-item-wrap-body p-international-filter__box-item-wrap-body--min"
                      >
                        <ng-container>
                          <asw-range-slider
                            *ngIf="bound.transitTimeRange.limitMinValue"
                            [type]="'interval'"
                            [valueMin]="bound.transitTimeRange.limitMinValue"
                            [valueMax]="990"
                            [handlePoint]="'one'"
                            [ariaLabel]="'reader.transferconditionTime'"
                            [stepGrid]="30"
                            [disabled]="!bound.transitTimeRangeEnabled"
                            formControlName="transitTimeRangeControl"
                          ></asw-range-slider>
                          <asw-range-slider
                            *ngIf="!bound.transitTimeRange.limitMinValue"
                            [type]="'interval'"
                            [valueMin]="0"
                            [valueMax]="990"
                            [handlePoint]="'one'"
                            [ariaLabel]="'reader.transferconditionTime'"
                            [stepGrid]="30"
                            [disabled]="!bound.transitTimeRangeEnabled"
                            formControlName="transitTimeRangeControl"
                          ></asw-range-slider>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>

            <div class="p-international-filter__box-inner">
              <div class="p-international-filter__box-unit">
                <!-- 運航キャリア -->
                <h2 class="p-international-filter__box-title" [innerHTML]="'label.service' | staticMsg"></h2>
                <div class="p-international-filter__box-item">
                  <div class="p-international-filter__box-item-wrap">
                    <h3
                      class="p-international-filter__box-item-wrap-head"
                      [innerHTML]="'label.operationAirlines' | staticMsg"
                    ></h3>
                    <div class="p-international-filter__box-item-wrap-body">
                      <fieldset class="c-checkbox-list c-checkbox-list--vertical" aria-invalid="false">
                        <legend
                          class="c-checkbox-list__legend"
                          [innerHTML]="'label.operationAirlines' | staticMsg"
                        ></legend>
                        <div class="c-checkbox-list__wrap">
                          <div class="c-checkbox-list__list">
                            <ng-container *ngFor="let airline of bound.operationAirlineList; index as airlineIndex">
                              <div class="c-checkbox-list__item">
                                <div class="c-form-element-checkbox">
                                  <div class="c-form-element-checkbox__wrap">
                                    <input
                                      type="checkbox"
                                      name="checkbox-operation-airline"
                                      id="{{ 'checkbox-operation-airline-' + boundIndex + '-' + airlineIndex }}"
                                      class="c-form-element-checkbox__input"
                                      [(ngModel)]="airline.isEnabled"
                                      [ngModelOptions]="{ standalone: true }"
                                    />
                                    <label
                                      for="{{ 'checkbox-operation-airline-' + boundIndex + '-' + airlineIndex }}"
                                      class="c-form-element-checkbox__label"
                                    >
                                      <span class="c-form-element-checkbox__check"></span>
                                      <span
                                        class="c-form-element-checkbox__text"
                                        *ngIf="airline.value === this.appConstants.CARRIER.TWO_LETTER"
                                        [innerHTML]="'label.nhLink' | staticMsg"
                                      ></span>
                                      <span
                                        class="c-form-element-checkbox__text"
                                        *ngIf="airline.value !== this.appConstants.CARRIER.TWO_LETTER"
                                        [innerHTML]="airline.name"
                                      ></span>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                </div>

                <div class="p-international-filter__box-item">
                  <div class="p-international-filter__box-item-wrap">
                    <!-- 機種 -->
                    <h3
                      class="p-international-filter__box-item-wrap-head"
                      [innerHTML]="'label.itineraryDetailsBoarding' | staticMsg"
                    ></h3>
                    <div class="p-international-filter__box-item-wrap-body">
                      <fieldset class="c-checkbox-list c-checkbox-list--vertical" aria-invalid="false">
                        <legend
                          class="c-checkbox-list__legend"
                          [innerHTML]="'label.itineraryDetailsBoarding' | staticMsg"
                        ></legend>
                        <div class="c-checkbox-list__wrap">
                          <div class="c-checkbox-list__list">
                            <ng-container *ngFor="let aircraft of bound.aircraftList; index as aircraftIndex">
                              <div class="c-checkbox-list__item">
                                <div class="c-form-element-checkbox">
                                  <div class="c-form-element-checkbox__wrap">
                                    <input
                                      type="checkbox"
                                      name="checkbox-aircraft"
                                      id="{{ 'checkbox-aircraft-' + boundIndex + '-' + aircraftIndex }}"
                                      class="c-form-element-checkbox__input"
                                      [(ngModel)]="aircraft.isEnabled"
                                      [ngModelOptions]="{ standalone: true }"
                                    />
                                    <label
                                      for="{{ 'checkbox-aircraft-' + boundIndex + '-' + aircraftIndex }}"
                                      class="c-form-element-checkbox__label"
                                    >
                                      <span class="c-form-element-checkbox__check"></span>
                                      <span class="c-form-element-checkbox__text" [innerHTML]="aircraft.item"></span>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
  <div #modalFooter class="l-modal05__footer is-shadow js-modal-footer">
    <div class="p-modal-foot02">
      <div class="p-modal-foot02__content">
        <button
          id="resetall-btn"
          class="c-btn-secondary c-btn-secondary--s c-btn-secondary--min-w100"
          (throttleClick$)="this.filterDataReset()"
          aswThrottleClick
        >
          <span class="c-btn-secondary__text" [innerHTML]="'label.resetall' | staticMsg"></span>
        </button>
      </div>

      <div class="p-modal-foot02__content">
        <button
          id="filter-condition-apply-btn"
          class="c-btn-primary c-btn-primary--s c-btn-primary--min-w100"
          (throttleClick$)="applyDialog(this.filterConditionData)"
          [disabled]="applyDisabled"
          aswThrottleClick
        >
          <span class="c-btn-primary__text" [innerHTML]="'label.confirm' | staticMsg"></span>
        </button>
      </div>
    </div>
  </div>
</div>
